import axios from 'axios'
import {
  ax_get_agencies,
  ax_get_fpool_general,
  ax_get_fpool_special,
  ax_get_parameters,
  ax_get_products,
  ax_get_quotedoc,
  ax_get_residence_municipalities,
  ax_get_vehicle_informations,
  ax_get_vehicle_models,
  ax_get_vehicle_versions,
  ax_post_otherdoc,
  ax_post_otherdocs,
  ax_post_quote,
  ax_post_quotedoc,
  ax_post_support_agency,
} from 'src/types'
import { get_language } from 'src/utils'
import { v4 } from 'uuid'

import { axios_request, configify, GET, POST, VERSION_V1 } from './base.axios'

const BASE_URL = process.env.REACT_APP_BASE_URL_PRODUCT || ''

/**
 * Product client
 */
export const product_client = axios.create(configify({ base_url: BASE_URL }))

/**
 * GET fpool general
 */
export const get_fpool_general = (params: ax_get_fpool_general): axios_request => ({
  url: `/${VERSION_V1}/formitems`,
  method: GET,
  params,
})

/**
 * GET fpool special
 */
export const get_fpool_special = ({ id, ...params }: ax_get_fpool_special): axios_request => ({
  url: `/${VERSION_V1}/products/${id}`,
  method: GET,
  params,
})

/**
 * GET products
 */
export const get_products = (params: ax_get_products): axios_request => ({
  url: `/${VERSION_V1}/products`,
  method: GET,
  params,
})

/**
 * GET vehicle brands
 */
export const get_vehicle_brands = (params: ax_get_vehicle_informations): axios_request => ({
  url: `/${VERSION_V1}/brands`,
  method: GET,
  params,
})

/**
 * GET vehicle models
 */
export const get_vehicle_models = (params: ax_get_vehicle_models): axios_request => ({
  url: `/${VERSION_V1}/models`,
  method: GET,
  params,
})

/**
 * GET vehicle versions
 */
export const get_vehicle_versions = (params: ax_get_vehicle_versions): axios_request => ({
  url: `/${VERSION_V1}/versions`,
  method: GET,
  params,
})

/**
 * GET residence municipalities TODO
 */
export const get_residence_municipalities = (
  params: ax_get_residence_municipalities
): axios_request => ({
  url: `/api/jsonws/GestAgenzie-portlet.comune/get-comuni-by-provincia-json`,
  method: GET,
  params,
})

/**
 * POST quote
 */
export const post_quote = ({
  company,
  product,
  channel,
  startDate,
  captcha,
  ...data
}: ax_post_quote): axios_request => ({
  url: `/${VERSION_V1}/quote`,
  method: POST,
  headers: {
    requestId: v4(),
    captcha: captcha,
    language: data?.language,
  },
  params: { company, product, channel, startDate },
  data,
})

/**
 * GET agencies
 */
export const get_agencies = ({
  latitudine = 0,
  longitudine = 0,
  cod_compagnia,
}: ax_get_agencies): axios_request => ({
  url: `/${VERSION_V1}/agency/locations`,
  method: GET,
  params: {
    latitudine,
    longitudine,
    cod_compagnia,
  },
})

/**
 * POST support agency
 */
export const post_support_agency = ({
  language,
  ...data
}: ax_post_support_agency): axios_request => ({
  url: `/${VERSION_V1}/sendemail/supportagency`,
  method: POST,
  headers: {
    requestId: v4(),
    captcha: 'captcha',
    language,
  },
  data,
})

/**
 * GET quote document
 */
export const get_quotedoc = ({ id }: ax_get_quotedoc): axios_request => ({
  url: `/${VERSION_V1}/quotations/${id}/print`,
  method: GET,
  headers: {
    requestId: v4(),
    language: get_language(),
  },
})

/**
 * POST quote document
 */
export const post_quotedoc = ({ id, ...data }: ax_post_quotedoc): axios_request => ({
  url: `/${VERSION_V1}/quotations/${id}/sendemail`,
  method: POST,
  headers: {
    requestId: v4(),
    language: get_language(),
  },
  data,
})

/**
 * POST other documents
 */
export const post_otherdocs = ({ sector, ...data }: ax_post_otherdocs): axios_request => ({
  url: `/${VERSION_V1}/documents/quotation`,
  method: POST,
  params: { sector },
  data,
})

/**
 * POST other document
 */
export const post_otherdoc = (data: ax_post_otherdoc): axios_request => ({
  url: `/${VERSION_V1}/documents/quotation/details`,
  method: POST,
  data,
})

/**
 * GET parameters
 */
export const get_parameters = ({ ...params }: ax_get_parameters): axios_request => ({
  url: `/${VERSION_V1}/parameters`,
  method: GET,
  headers: {
    language: get_language(),
  },
  params,
})

/**
 * GET generic document
 */
export const get_document = (id: string): axios_request => ({
  url: `/${VERSION_V1}/document/${id}`,
  method: GET,
})
